
import {login,tiemposesion } from 'store/slice/authSlice';

export const doLogin =  (credentials)=>{

    return async(dispatch, getState)=>{

        /*
        const response = await  persona.loggin(credentials);
        if(response.status == 'error'){
            dispatch( logout() );
            sessionStorage.clear();
        }else {
            dispatch(login(response));
            sessionStorage.setItem("session", JSON.stringify( response.response ) );
            console.log(getState().auth);
        }
        */
        localStorage.setItem("cToken", credentials.token);
        localStorage.setItem("session", JSON.stringify( credentials ) );
        localStorage.setItem("cRefreshToken", credentials.refreshToken );

        const tabs = JSON.parse(localStorage.getItem("app:tabs") || "{}");
        localStorage.setItem("app:tabs", JSON.stringify( tabs ));
        dispatch(login(credentials));
    }

    
}

export const doConfigurarIdleSesion = (tiempo) =>{
    return async(dispatch, getState)=>{
        const data = JSON.parse(localStorage.getItem("session"))
        data.idle_timeout = parseInt(tiempo);
        localStorage.setItem("session", JSON.stringify( data ) );
        dispatch(tiemposesion(tiempo));
    }
}